// @flow
import { omitBy, isNil } from 'lodash/fp';

import decodeGiftImage from './decodeGiftImage';

type Purchase = {
  createdAt: string,
  expiryDate?: string,
  id: number | string,
  image: {
    res1x: string,
    res2x: string
  },
  name: string,
  pin?: number | string,
  price?: string,
  status: {
    id: number,
    name: string
  },
  voucherCode?: number,
  credentialInfo?: Array<Object>
};

const omitNil = omitBy(isNil);

function decodePurchase(p: Object = {}): Purchase {
  return omitNil({
    createdAt: p.created_at,
    expiryDate: p.expiry_date,
    id: p.id || p.created_at,
    image: decodeGiftImage(p.product.image),
    name: p.product.name,
    price: p.product.price,
    status: p.status,
    voucherCode: p.voucher_code,
    pin: p.pin,
    credentialInfo: p.credential_info
  });
}

export default decodePurchase;
